export const getLoggedInUserId = (state) => state.api.loggedInUserId;

export const getLoggedInUser = (state) => state.api.loggedInUserId ? state.api.entities.users[state.api.loggedInUserId] : undefined;

export const getUserAccessTokenFromProps = (state) => state.api.accessToken ? state.api.accessToken : undefined;

export const getInitializationComplete = (state) => state.menu.initializationComplete ?  state.menu.initializationComplete : false;